import React from "react";
import Banner from "./Banner";
import Skills from "./Skills";
import Works from "./Works";
import Contact from "./Contact";
import Loader from "./Loader";
import { useEffect, useState } from "react";

function Main() {
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  }, []);
  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <>
          <Banner />
          <Skills />
          <Works />
          <Contact />
        </>
      )}
    </div>
  );
}

export default Main;
